import React from 'react';
import { useTranslatedContent } from '../../../i18n/hooks/useTranslatedContent';
import { Check } from 'lucide-react';

interface WhyChooseUsProps {
  title: string;
  points: string[];
}

const WhyChooseUs: React.FC<WhyChooseUsProps> = ({ title, points }) => {
  if (!Array.isArray(points)) {
    return null;
  }

  return (
    <div className="mt-16 bg-white rounded-2xl shadow-lg p-8">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-8 items-center">
        <div>
          <h3 className="text-2xl font-semibold text-gray-900 mb-4">
            {title}
          </h3>
          <ul className="space-y-4">
            {points.map((point, index) => (
              <li key={index} className="flex items-start">
                <Check className="h-6 w-6 text-blue-600 mr-2 mt-1" />
                <span className="text-gray-600">{point}</span>
              </li>
            ))}
          </ul>
        </div>
        <div className="relative">
          <img
            src="https://images.unsplash.com/photo-1553877522-43269d4ea984?ixlib=rb-1.2.1&auto=format&fit=crop&w=1950&q=80"
            alt="Open Source Solutions"
            className="rounded-lg shadow-md"
          />
        </div>
      </div>
    </div>
  );
};

export default WhyChooseUs;